import { SET_COMPARE_ERROR } from './compare-actions';

const CompareResultsReducer = (state = true, action) => {
    Object.freeze(state);
    switch (action.type) {
        case SET_COMPARE_ERROR:
            return action.error;
        default:
            return state;
    }
};

export default CompareResultsReducer;             